module.exports = __webpack_public_path__ + "static/media/APP_OfficeChamp_152x174_5.f25ed553.png";